import addDays from 'date-fns/addDays';
import axiosClient from 'utils/axiosBaseClient';

export interface SecretsData {
   googleMapsClientAPIKey: string;
   'recaptcha-siteKey': string;
   mapBoxAccessToken: string;
   surveyJsLicenseKey?: string;
   posthogKey?: string;
   NODE_ENV: string;
   CUSTOMER: string;
}

interface CachedData<T> {
   value: T;
   expiry: number;
}

/**
 * Retrieves secrets from local storages or fetches them from the secrets API if not cached or expired.
 */
export const getSecrets = async (): Promise<SecretsData> => {
   const localStorageKey = 'applicationServiceDataObject';
   const cachedDataString = localStorage.getItem(localStorageKey);
   const now = new Date();

   if (cachedDataString) {
      try {
         const parsedData: CachedData<SecretsData> = JSON.parse(cachedDataString);
         if (now.getTime() < parsedData.expiry) {
            return parsedData.value;
         } else {
            localStorage.removeItem(localStorageKey);
         }
      } catch (error) {
         console.error('Error parsing cached secrets:', error);
         localStorage.removeItem(localStorageKey);
      }
   }

   try {
      const response = await axiosClient.get<SecretsData>(`/auth/secrets`);
      const dataToStore: CachedData<SecretsData> = {
         value: response.data,
         expiry: addDays(now, 1).getTime(),
      };
      try {
         localStorage.setItem(localStorageKey, JSON.stringify(dataToStore));
      } catch (error) {
         console.error('Error saving secrets to localStorage:', error);
      }
      return response.data;
   } catch (error) {
      console.error('Error fetching secrets from API:', error);
      throw error;
   }
};
